import React from 'react';
import StatusBadge from '../base/StatusBadge';

interface JobCardProps {
  orderId: string;
  branchName: string;
  distance: string;
  eta: string;
  payout: string;
  status: 'new' | 'preparing' | 'ready' | 'onway' | 'delivered' | 'cancelled';
  pickupTime: string;
  paymentType: string;
  onClick?: () => void;
}

export default function JobCard({
  orderId,
  branchName,
  distance,
  eta,
  payout,
  status,
  pickupTime,
  paymentType,
  onClick,
}: JobCardProps) {
  const statusTexts = {
    new: 'Ny',
    preparing: 'Förbereder',
    ready: 'Redo',
    onway: 'På väg',
    delivered: 'Levererad',
    cancelled: 'Avbruten',
  };
  
  return (
    <div
      onClick={onClick}
      className="bg-white rounded-2xl p-4 shadow-md border border-gray-100 hover:shadow-lg transition-shadow cursor-pointer"
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-mono font-bold text-gray-900">#{orderId}</span>
            <StatusBadge status={status} text={statusTexts[status]} size="small" />
          </div>
          <p className="text-sm font-semibold text-gray-700">{branchName}</p>
        </div>
        <div className="text-right">
          <p className="text-lg font-bold text-[#E31837]">{payout} SEK</p>
          <p className="text-xs text-gray-500">{paymentType}</p>
        </div>
      </div>
      
      <div className="flex items-center gap-4 pt-3 border-t border-gray-100">
        <div className="flex items-center gap-1.5">
          <i className="ri-map-pin-distance-line text-base text-gray-600"></i>
          <span className="text-sm font-semibold text-gray-900">{distance}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <i className="ri-time-line text-base text-gray-600"></i>
          <span className="text-sm font-semibold text-gray-900">{eta}</span>
        </div>
        <div className="flex items-center gap-1.5 ml-auto">
          <i className="ri-timer-line text-base text-gray-600"></i>
          <span className="text-xs text-gray-600">{pickupTime}</span>
        </div>
      </div>
    </div>
  );
}
